import { render, staticRenderFns } from "./ProjectToolbar.vue?vue&type=template&id=a2c70542&"
import script from "./ProjectToolbar.vue?vue&type=script&lang=js&"
export * from "./ProjectToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectToolbar.vue?vue&type=style&index=0&id=a2c70542&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports